import React, { useEffect, useState, useRef } from 'react'
import { useVeille } from '../../redux/Hooks';
import { defaultTimeoutMilliseconds } from '../../model/Configuration';

const SlideShow = (props: {
	switchComponent: Function,
	loop: boolean
}) => {
  const veille = useVeille();
  const [currentIndex, setCurrentIndex] = useState<number>(0);
  const timerRef: React.MutableRefObject<any> = useRef(null);

  useEffect(() => {
    timerRef && clearTimeout(timerRef.current);
    if(veille?.slideShow?.sources && veille?.slideShow?.sources.length > 0) {
      timerRef.current = setTimeout(() => {
        //@ts-ignore
        currentIndex === (veille.slideShow.sources.length - 1) ?
          props.loop ?
            setCurrentIndex(0)
            :
            props.switchComponent()
          :
          setCurrentIndex(currentIndex + 1)
      }, veille?.slideShow?.timeBeforeSwitch ? veille?.slideShow?.timeBeforeSwitch * 1000 : defaultTimeoutMilliseconds)
    } else {
      props.switchComponent();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentIndex])

  useEffect(() => {
    return () => timerRef && clearTimeout(timerRef.current);
  }, [])

  return (
    <div className='h-full w-full flex justify-center items-center bg-black'>
      <img
        className={`${window.innerHeight > window.innerWidth ? 'w-full' : 'h-full'}`}
        src={veille?.slideShow?.sources[currentIndex] || ''}
        alt="slideshow"
      />
    </div>
  )
}

export default SlideShow;
